import { Slot } from '@radix-ui/react-slot';
import type { ComponentProps } from 'react';
import { cn } from '../lib/utils.js';
import { buttonVariants, type ButtonVariantProps } from './button-variants.js';

export type ButtonProps = ComponentProps<'button'> &
  ButtonVariantProps & {
    /** Renderiza el hijo directo en lugar de un `<button>` (p. ej. un enlace). */
    asChild?: boolean;
  };

/**
 * @example
 * <Button variant="outline" size="sm" onClick={retry}><RefreshCw /> Reintentar</Button>
 */
export function Button({ className, variant, size, asChild = false, ...props }: ButtonProps) {
  const Component = asChild ? Slot : 'button';
  return (
    <Component
      data-slot="button"
      className={cn(buttonVariants({ variant, size }), className)}
      {...props}
    />
  );
}
